//internal import
import Layout from '@layout/Layout';
import Coupon from '@component/coupon/Coupon';
import PageHeader from '@component/header/PageHeader';
import ProductServices from "@services/ProductServices";
import ProductCard from "@component/product/ProductCard";
import Head from "next/head";
import { useFeatureFlagEnabled } from 'posthog-js/react'

const Offer = ({ discountProducts }) => {
  const flagEnabled = useFeatureFlagEnabled('eid-sale')
  return (
    <>
      <Layout title="Offer" description="Latest offers at CubeNation">
        <Head>
          <meta property="og:title" content="Offers at CubeNation" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.cubenationshop.com/offer" />
          <meta property="og:image" content="/facebook-page.png" />
          <meta
            property="og:description"
            content="CubeNation is one of the largest Speed cube shops in BD. It's simply a Puzzle Bazaar & cube collection store!"
          />
        </Head>
        <PageHeader title="Mega Offer" />
        <div className="mx-auto max-w-screen-2xl px-4 py-10 lg:py-20 sm:px-10">
          <div className="grid gap-6 grid-cols-1 xl:grid-cols-2">
            {//<Coupon />
            }          </div>
          {/* discounted products - only show when eid-sale flag is disabled */}
          {!flagEnabled && (
            <div
              id="discount"
              className="bg-gray-50 lg:py-16 py-10 mx-auto max-w-screen-2xl px-3 sm:px-10"
            >
              <div className="mb-10 flex justify-center">
                <div className="text-center w-full lg:w-2/5">
                  <h2 className="text-xl lg:text-2xl mb-2 font-serif font-semibold">
                    Puzzles on Sale
                  </h2>
                  <p className="text-base font-sans text-gray-600 leading-6">
                    Choose your puzzle from here and avail discounts!
                  </p>
                </div>
              </div>
              <div className="flex">
                <div className="w-full">
                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-6 gap-2 md:gap-3 lg:gap-3">
                    {discountProducts?.slice(0, 100).map((product) => (
                      <ProductCard key={product._id} product={product} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
          {flagEnabled && (
            <div
              id="eid-discount"
              className="bg-gray-50 lg:py-16 py-10 mx-auto max-w-screen-2xl px-3 sm:px-10"
            >
              <div className="mb-10 flex justify-center">
                <div className="text-center w-full lg:w-2/5">
                  <h2 className="text-xl lg:text-2xl mb-2 font-serif font-semibold">
                    Everything on Sale
                  </h2>
                  <p className="text-base font-sans text-gray-600 leading-6">
                    Order whatever you like
                  </p>
                </div>
              </div>
            </div>
          )}

        </div>
      </Layout>
    </>
  );
};

export const getServerSideProps = async () => {
  const [discountProducts] =
    await Promise.all([
      ProductServices.getDiscountedProducts(),
    ]);

  return {
    props: {
      discountProducts: discountProducts,
    },
  };
};

export default Offer;
